/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getKybEligibilityWarningInternal} from '../api'

 export const useQueryGetKybEligibilityWarningInternal = createReactQueryHook('getKybEligibilityWarningInternal', getKybEligibilityWarningInternal)
